import { useLocation } from 'react-router-dom';
import { useAuthProviderV2, useRoutesProvider } from '../../providers/provider-hooks';
import { resolvePostAuthTarget } from '../../domains/auth/utils/resolve-post-auth-target';
import { pasiInscriereActive } from '../../domains/auth/utils/pasi-inscriere';

interface AuthRedirectResult {
  redirectTo: string | null;
}

/**
 * Wrapper subtire peste `resolvePostAuthTarget`.
 *
 * Toata logica pe stagii sta in functia pura, ca sa fie una singura si testabila. Aici raman doar
 * hook-urile care aduc contextul.
 *
 * Ce s-a scos la unificare (2026-08-21):
 * - `console.log`-urile din blocul ELEV (~20 de linii de debug ajunse in productie);
 * - fostul „Stage 3": conditia `isApproved !== true && isApproved !== false` nu putea fi
 *   adevarata niciodata, pentru ca backendul pune mereu un boolean. Ii ia locul regula pe
 *   `hasPendingSchoolRequest`;
 * - blocul `FORCE_SCHOOL_UPDATE`: flag-ul e `enabled: false` in `constants/config.ts`, deci era
 *   cod mort. Toast-ul echivalent, tot pe cutoff, ramane in `AuthenticatedLayout`.
 */
export function useAuthRedirects(): AuthRedirectResult {
  const { userInfo } = useAuthProviderV2();
  const { ROLES, PATHS, PAGES, getUserHomePage } = useRoutesProvider();
  const location = useLocation();

  return {
    redirectTo: resolvePostAuthTarget(userInfo, location.pathname, {
      PATHS,
      PAGES,
      ROLES,
      getUserHomePage,
      pasiInscriere: pasiInscriereActive(),
    }),
  };
}
